export default (text, container) => {
    /* Container can be used to allow for 'focus' method stay usable when something is covering the document body, like a modal for example */

    if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text);
        return;
    }

    if (!document.queryCommandSupported('copy')) {
        return;
    }

    if (!container) {
        container = document.body;
    }

    const clipboard_textarea = document.createElement('textarea');
    clipboard_textarea.style.border = 'none';
    clipboard_textarea.style.background = 'transparent';
    clipboard_textarea.style.boxShadow = 'none';
    clipboard_textarea.style.outline = 'none';
    clipboard_textarea.style.width = '10px';
    clipboard_textarea.style.height = '10px';
    clipboard_textarea.style.position = 'fixed';
    clipboard_textarea.style.padding = '0';
    clipboard_textarea.style.bottom = '0';

    clipboard_textarea.innerHTML = text;
    clipboard_textarea.innerText = text;

    container.appendChild(clipboard_textarea);
    clipboard_textarea.focus();
    clipboard_textarea.select();

    document.execCommand('copy');

    clipboard_textarea.remove();
};